import React from 'react';

const IMyLearningJourney = () => {
  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width="18.232" height="18" viewBox="0 0 18.232 18">
          <g id="route" transform="translate(20.217 -2.24) rotate(90)">
            <path id="Path_1823398" data-name="Path 1823398" d="M19,20a1,1,0,1,0-1-1A1,1,0,0,0,19,20Zm0,2a3,3,0,1,0-3-3A3,3,0,0,0,19,22Z" transform="translate(-1.76 -1.783)" fillRule="evenodd"/>
            <path id="Path_1823399" data-name="Path 1823399" d="M14.235,3.822A2.251,2.251,0,0,0,12.01,6.1V16.118a4.053,4.053,0,0,1-4,4.1,4.053,4.053,0,0,1-4-4.1V9.287a.89.89,0,1,1,1.78,0v6.831a2.226,2.226,0,1,0,4.45,0V6.1a4.006,4.006,0,1,1,8.01,0v5.92a.89.89,0,1,1-1.78,0V6.1A2.251,2.251,0,0,0,14.235,3.822Z" fillRule="evenodd"/>
            <path id="Path_1823400" data-name="Path 1823400" d="M4.136,2.481a1,1,0,0,1,1.728,0L7.623,5.5A1,1,0,0,1,6.759,7H3.241a1,1,0,0,1-.864-1.5Z" />
          </g>
        </svg>
    </>
  )
};

export default IMyLearningJourney;
